import { ServiceType } from "@/models/club";
import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface MessageListState {
  serviceType?: ServiceType;
  setServiceType: (e: ServiceType | undefined) => void;
}

const useMessageList = create<MessageListState>()(
  devtools(
    (set) => ({
      serviceType: undefined,
      setServiceType: (serviceType: ServiceType | undefined) =>
        set(() => ({ serviceType: serviceType })),
    }),
    { name: "messageListStore" }
  )
);

export default useMessageList;
